@if (navigationItems$ | async) {
  <agr-wrapper-site-sidenav data-test="site-root">
    <router-outlet></router-outlet>
  </agr-wrapper-site-sidenav>
}
@if (report$ | async; as report) {
  <app-report-print [report]="report"></app-report-print>
}
